export default __webpack_public_path__ + "static/media/30-460x460.9bed3f75.jpeg";